import { ResetPasswordRequestForm } from 'components/core-v2'
import { useNavigate } from 'react-router-dom'

import { PATH } from '../../../const'
import { COPY } from '../constants'
import { TwoColumnWithImage } from '../templates/TwoColumnWithImage'

export const ResetPasswordRequest = () => {
  const navigate = useNavigate()
  const onSuccess = () => navigate(PATH.resetPasswordSent)

  return (
    <TwoColumnWithImage
      mainElement={<ResetPasswordRequestForm onSuccess={onSuccess} />}
      title={COPY.resetPassword.title}
    />
  )
}
